import useCompanyReviewWorkLife from '~hooks/query/company/useCompanyReviewWorkLife';
import { useRouterQuery } from '~hooks/useRouterQuery';

import * as S from '../style';
import BarChart from './BarChart';
import PieChart from './PieChart';

export default function ChartContents() {
  const companyId = useRouterQuery('companyId');
  const { data: chartData, isEmptyOvertime, isEmptyWeekend } = useCompanyReviewWorkLife(companyId);

  return (
    <S.ChartSectionWrapper>
      <S.ChartSection>
        <S.Subject>야근은 일주일에 몇 번 하시나요?</S.Subject>
        <BarChart chartData={chartData?.overtime} isEmpty={isEmptyOvertime} />
      </S.ChartSection>
      <S.ChartSection>
        <S.Subject>주말이나 휴일에 출근 하시나요?</S.Subject>
        <PieChart chartData={chartData?.weekend} isEmpty={isEmptyWeekend} />
      </S.ChartSection>
    </S.ChartSectionWrapper>
  );
}
